import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Tickets',
	url: '/tickets',
	icon: 'ticket',
}];

class Tickets extends Framework.Components.View {

	render() {
		let {history,roles} = this.props;

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}/>

				<Collections.Tickets
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={roles.includes(UserRoles.Admin)}
					roles={roles}
					filter={roles.includes(UserRoles.FieldEngineer) ? this.state.filter = {"user" : this.props.rootState.user} : null}
					parent={(roles.length === 1 && roles[0] === 40) ? this.props.rootState.user : null}
				/>

			</div>
		);
	}
}
export default Framework.Components.withRootState(Tickets)
